import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { validateEmail } from '../util';
import { BACKEND_URL } from '../consts';


const Recovery = () => {
    const [email, setEmail] = useState('');
    const [emailBorderColor, setEmailBorderColor] = useState('#353A40');
    const [emailImg, setEmailImg] = useState("./ula.png");
    const [error, setError] = useState(null)
    const submitData = async () => {
        // Сохраняем адрес электронной почты в куки
        localStorage.setItem('email', email);

        try {
            // Отправляем POST запрос
            const response = await axios.post(`${BACKEND_URL}/api/v1/auth/password-reset`, {
                email: email
            });

            localStorage.setItem('passwordResetCodeHash', response.data.hashedCode);

            // Обработка успешного ответа
            console.log('Response:', response.data);
            setError(null); // Сбрасываем ошибку при успешном ответе
            window.location.replace("/password-reset-code")
        } catch (error) {
            // Обработка ошибок
            console.error('Error:', error.response ? error.response.data : error.message);

            // Проверяем статус ошибки и сохраняем соответствующее сообщение
            if (error.response && error.response.status === 401) {
                setError("Пользователь не найден");
            } else {
                setError("Произошла ошибка. Попробуйте еще раз.");
            }
        }
    };

    // const validateEmail = (email) => {
    //     const re = /^[^s@]+@[^s@]+.[^s@]+$/;
    //     return re.test(String(email).toLowerCase());
    // };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (validateEmail(value)) {
            setEmailBorderColor('#34C759'); // зеленый при валидном email
            setEmailImg("./Succes.png");
        } else {
            setEmailBorderColor('#C3372E'); // красный при ошибке
            setEmailImg("./dot-error.png");
        }
    };
    return (
        <>
            <div className='w-full p-8 h-screen hidden lg:grid lg:grid-cols-2'>
                <div className='w-full h-full gap-6 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]' >Восстановить пароль</span>
                    <span className='text-[16px] text-[#4B535B]'>Введите ваш email и мы вышлем вам ссылку для восстановления</span>
                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='w-[60%] flex justify-between items-center'>
                        <a href='/login' className='flex border-[#353A40] border-[1px] flex-row hover:text-[#fff] text-black justify-between rounded-full w-[35%] py-4 px-6 bg-[#FFF] hover:bg-[#353A40]'>
                            <img className='w-7' src='./Arrow_left.png' />
                            <span className='text-[20px]'>Назад</span>
                        </a>

                        <div className='flex flex-row justify-between rounded-full w-[60%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]'>
                            <span className='text-white text-[20px]' onClick={submitData}>Восстановить</span>
                            <img className='w-7' src='./Arrow_right.png' />
                        </div>
                    </div>

                </div>

                <img style={{ aspectRatio: 1 }} className='w-full my-auto' src='/AuthBg.png' />
            </div>












            <div className='w-full p-8 min-h-screen hidden sm:grid lg:hidden lg:grid-cols-1'>
                <img className='w-full my-auto' src='/AuthBgLaptop.png' />

                <div className='w-full h-full gap-6 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Восстановить пароль</span>
                    <span className='text-[16px] text-[#4B535B]'>Введите ваш email и мы вышлем вам ссылку для восстановления</span>
                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='w-[80%] flex justify-between items-center'>
                        <a href='/login' className='flex border-[#353A40] border-[1px] flex-row hover:text-[#fff] text-black justify-between rounded-full w-[35%] py-4 px-6 bg-[#FFF] hover:bg-[#353A40]'>
                            <img className='w-7' src='./Arrow_left.png' />
                            <span className='text-[20px]'>Назад</span>
                        </a>

                        <div className='flex flex-row justify-between rounded-full w-[60%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]'>
                            <span className='text-white text-[20px]' onClick={submitData}>Восстановить</span>
                            <img className='w-7' src='./Arrow_right.png' />
                        </div>
                    </div>

                </div>

            </div>









            <div className='w-full p-8 min-h-screen grid sm:hidden lg:grid-cols-1'>

                <div className='w-full h-full gap-6 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' />
                    <span className='font-medium text-[40px]'>Восстановить пароль</span>
                    <span className='text-[16px] text-[#4B535B]'>Введите ваш email и мы вышлем вам ссылку для восстановления</span>
                    <div className={`py-2 px-4 w-[100%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Отображение ошибки */}

                    <div className='w-full flex justify-between items-center'>
                        <a href='/login' className='flex border-[#353A40] border-[1px] flex-row hover:text-[#fff] text-black justify-between rounded-full w-[35%] py-4 px-4 bg-[#FFF] hover:bg-[#353A40]'>
                            <img className='w-7' src='./Arrow_left.png' />
                            <span className='text-[20px]'>Назад</span>
                        </a>

                        <div className='flex flex-row justify-between rounded-full w-[60%] py-4 px-8  bg-[#C3372E] hover:bg-[#E0473F]'>
                            <span className='text-white text-[20px]' onClick={submitData}>Восстановить</span>
                            <img className='w-7' src='./Arrow_right.png' />
                        </div>
                    </div>

                </div>

                <img className='w-full mt-8 my-auto' src='/AuthBgMobile.png' />

            </div>
        </>

    );
};

export default Recovery;

